import React from 'react'
import PropTypes from 'prop-types'

import styles from './buttonToggle.module.scss'

const ButtonToggle = ({ options, idBy, displayBy, value, onChange, className = '', ...rest }) => {
  return (
    <div className={`${styles.buttonToggle} ${className}`} {...rest}>
      {options?.map((opt) => {
        const buttonClass = value === opt[idBy] ? styles.buttonToggle__active : ''
        return (
          <div key={opt[idBy]}>
            <button
              type="button"
              onClick={() => {
                onChange(opt[idBy])
              }}
              className={buttonClass}
            >
              {opt[displayBy]}
            </button>
          </div>
        )
      })}
    </div>
  )
}

ButtonToggle.displayName = 'ButtonToggle'

ButtonToggle.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  idBy: PropTypes.string,
  displayBy: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

export { ButtonToggle }
